import stripline from './stripline';

// source: IPC-2141A Equation 4-17 (make sure to check errata)
export function characteristicImpedance(params) {
  const { e, h1, h2, t, w } = mapStandardParamsToFormulaParams(params);

  const z0ss = stripline.characteristicImpedance({
    ...params,
    dk: 1
  });

  const z0ssh1 = stripline.characteristicImpedance({
    ...params,
    dk: 1,
    dielectricUpHeight: h1,
    dielectricDownHeight: h1
  });

  const z0ssh2 = stripline.characteristicImpedance({
    ...params,
    dk: 1,
    dielectricUpHeight: h2,
    dielectricDownHeight: h2 
  });

  const z0air = 2 * z0ssh1 * z0ssh2 / (z0ssh1 + z0ssh2);
  const deltaZ0air = 0.0325 * Math.PI * Math.pow(z0air, 2)
    * Math.pow(0.5 - (1/2) * (2*h1+t)/(h1+h2+t), 2.2)
    * Math.pow((t+w)/(h1+h2+t), 2.9);
  const z0as = 1/Math.sqrt(e) * (z0ss - deltaZ0air);
  return z0as;
}

// source: http://referencedesigner.com/tutorials/si/si_11.php 
export function differentialImpedance(params) {
  const { b, d } = mapStandardParamsToFormulaParams(params);
  const z0 = stripline.characteristicImpedance(params);

  const zDiff = 2 * z0 * (1 - 0.347 * Math.exp(-2.9 * d/b));
  return zDiff;
}

export function propagationalDelay(params) {
  const { e } = mapStandardParamsToFormulaParams(params);
  
  const tPd = 1000 * (1.017 * Math.sqrt(e) / 12);
  return tPd;
}

export function mapStandardParamsToFormulaParams(params) {
  const {
    dielectricUpHeight,
    dielectricDownHeight,
    dk,
    thickness,
    transmissionSpacing,
    transmissionWidth
  } = params;

  return {
    e: dk,
    h1: Math.min(dielectricUpHeight, dielectricDownHeight),
    h2: Math.max(dielectricUpHeight, dielectricDownHeight),
    b: dielectricDownHeight + dielectricUpHeight + thickness,
    t: thickness,
    w: transmissionWidth,
    d: transmissionSpacing,
  }
}

export default {
  characteristicImpedance,
  differentialImpedance,
  propagationalDelay
}


// WEBPACK FOOTER //
// ./src/lib/simulations/formulas/asymmetric-stripline.js